export enum ResourceType {
	Video = 'video',
	Webcast = 'webcast'
}
